import React, { useState, useEffect } from 'react';
import { Button, FieldSet, Input, Label } from './Form.styles';

import getSubmissionCallback from './getSubmissionCallback';
import handleSelectOnFocus from './handleSelectOnFocus';

import handleSubmit from './handleSubmit';
import { useLocationContext } from '../../context/LocationContext';

const LABEL = 'zip code';

export default function Form() {
  const { zip, setGeolocation, onCloseHandler } = useLocationContext();
  const [inputValue, setInputValue] = useState(() => zip);

  useEffect(() => {
    setInputValue(zip);
  }, [zip]);

  return (
    <form
      data-testid="zipcode-form"
      onSubmit={handleSubmit(
        setGeolocation,
        inputValue,
        getSubmissionCallback(setInputValue, zip),
        onCloseHandler
      )}
      className="mt-24 flex align-top"
    >
      <FieldSet>
        <Input
          data-qa="zipcode-form-input"
          data-testid="zipcode-form-input"
          id={LABEL}
          maxLength={5}
          name="zipcode"
          onBlur={() => {
            if (inputValue === zip || !inputValue) {
              setInputValue(zip);
            }
          }}
          onFocus={handleSelectOnFocus}
          onChange={e => {
            setInputValue(e.currentTarget.value);
          }}
          value={inputValue}
          type="text"
          title="Please enter a valid zip code."
          placeholder="Zip Code"
          pattern="[0-9]{5}"
        />
        <Label
          data-qa="zipcode-form-label"
          data-testid="zipcode-form-label"
          htmlFor={LABEL}
        >
          {LABEL}
        </Label>
      </FieldSet>
      <Button
        data-analytics-id="Geolocation - Changed Zip"
        type="submit"
        data-testid="zipcode-form-submit"
      >
        UPDATE
      </Button>
    </form>
  );
}
